module.exports = {
  App: {
    name: '名称',
    number: '编号',
    phone: '手机',
    sms: '短信',
    email: '邮箱',
    id: 'ID',
    done: '完成',
    close: '关闭',
    floor: '楼层',
    company: '公司',
    position: '位置',
    remarks: '备注',
    password: '密码',
    account: '账号',
    delete: '删除',
    placeholder: {
      text1: '搜索用户名',
      text2: '搜索日志说明',
      text3: '搜索名称',
      text4: '请输入关键字搜索',
    },
    login: {
      text1: '欢迎回来!',
      text2: '祝您今日也拥有美好的一天！',
      text3: '请输入您的登录名',
      text4: '请输入您的密码',
      text5: '请输入验证码',
      text6: '登录',
      text7: '忘记密码',
      text8: '记住密码',
    },
    retrievePassword: {
      text1: '忘记密码',
      text2: '用户名',
      text3: '验证码',
      text4: '*为了您的帐户安全，您将收到一个安全密码更改链接到您的电子邮件。收到电子邮件后，即可更改您的密码。',
      text5: '新密码:',
      text6: '邮箱验证码:',
      text7: '发送',
    },
    header: {
      text1: '退出登录',
      text2: '国家',
      text3: '省份',
      text4: '城市',
      text5: '酒店',
    },
    grouping: {
      text1: '分组列表'
    },
    sideBar: {
      text1: '概览',
      text2: '房间',
      text3: 'LED灯',
      text4: '线条灯',
      text5: '开关面板',
      text6: '窗帘',
      text7: '普通灯',
      text8: 'HCL灯',
      text15: '传感器',
      text9: '空气净化器',
      text10: '网关',
      text11: '告警维修',
      text12: '操作日志',
      text13: '用户管理',
      text14: '酒店管理',
      text16: '单位',
      text17: '单位管理',
      text18: 'UV灯',

      text19: '项目区域',
      text20: '空气质量检测',
      text21: 'triliros管道杀菌器',
      text22: '项目管理',
      text23: '分组',
    },
    dashboard: {
      text1: '酒店日志',
      text2: '房间总数',
      text3: '空气净化器 (在线/总数)',
      text4_1: '传感器 (在线/总数)',
      text4_2: '',
      text4_3: '',
      text5: '普通灯控 (在线/总数)',
      text6_1: 'HCL灯控 (在线/总数)',
      text6_2: '',
      text7: '网关 (在线/总数)',
      text8: '室内环境指数',
      text9: '平均空气质量·当天',
      text10: '周',
      text11: '温度',
      text12: '湿度',
      text13: '甲醛',
      text14: '室外环境指数',
      text15: '风速',
      text16: '降雨量',
      text17: '气压',
      text18: '可见度',
      text19: '异常告警',
      text20: '当前总异常数',
      text21: '自定义',
      // text22:'Abnormality Detected',
      text23: '已解决的异常数（过去7天）',
      text24: '异常设备数',
      text25: '正在处理的异常数',
      text26: '室内平均温度',
      text27: '日',
      text28: '月',
      text29: '年',
      text30: '酒店总览',
      text31: '更多',
      text32: '普通灯',
      text33: 'HCL 路灯',
      text34: '传感器',
      text35: '空气净化器',
      text36: '告警设备量',
      text37: '房间数',
      text38: '室内空气质量',
      text39: '搜索酒店名称',
      text40: '室内平均值',
      text41: '(当前)',
      text42: '/室内平均值',
      text43: '日',
      text44: '周',
      text45: '月',
      text46: '提示:',
      text47: '空气质量参数',
      text48: '国际单位',
      text49: '室外空气质量指数',
      text50: '优秀的',
      text51: '较好的',
      text52: '一般的',
      text53: '单位日志',

      text54: 'LED灯 (在线/总数)',
      text55: '线条灯 (在线/总数)',
      text56: '开关面板 (在线/总数)',
      text57: '窗帘 (在线/总数)',
    },
    room: {
      text1: '房间',
      text2: '地图',
      text3: '搜索房间名称',
      text4: '平面图',
      text5: '模式设置',
      text6: '批量绑定',
      text7: '平面图',
      text8: '添加设备',
      text9: '正常设备',
      text10: '普通灯',
      text10_: 'HCL 路灯',
      text11: '传感器',
      text12: '空气净化器',
      text13: '空气质量指数',
      text14: '没有数据',
      text15: '在线',
      text16: '新建',
      text17: '告警',
      text18: 'ID',
      text19: '编号',
      text20: '类型',
      text21: '状态',
      text22: '楼层',
      text23: '房间',
      text24: '复制',
      text25: '粘贴',
      text26: '删除',
      text27: '模式设置',
      text28: '关闭',
      text29: '楼层',
      text30: '房间',
      text31: '亮度',
      text32: '色温',
      text33: '调色板',
      text34: '空气净化器',
      text35: '完成',
      text36: '楼层图',
      text37: '设备类型',
      text38: '设备数量',
      text39: '排列方式',
      text40: '间距',
      text41: '列号',
      text42: '名称',
      text43: '设备ID',
      text44: '设备编号',
      text45: '请上传1100*600像素的平面图',
      text46: '单击上传楼层背景',
      text47: '上传进度',
      text48: '当前文件：',
      text49: '上传失败',
      text50: '应用楼层',
      text51: '设备映射',
      text52: '下载excel文件',
      text53: '上传excel文件',
      text54: '选中所有设备',
      text55: '请按格式上传，或下载模板进行编辑',
      text56: '点击上传文件',
      text57: '错误提示',
      text58: '验证成功',
      text59: '下载',
      text60: '保存',
      text61: '用户身份验证',
      text62: '登录名:',
      text63: '密码:',
      text64: '确认',

      text65: '离线',
      text66: '在线',

      text67: '关',
      text67_: '无',
      text68: '低',
      text69: '中',
      text70: '高',

      text71: '并排',
      text72: '等距',
      text73: '矩阵',

      text74: '网关地址',
      text75: '添加其他设备',
      text76: '温度',
      text77: '湿度',

      text78: '房间设置',
      text79: '型号',
    },
    room_light: {
      text1: '返回',
      text2: '房间',
      text3: '时区：',
      text4: '当前时间：',
      text5: '起床时间：',
      text6: '设备管理',
      text7: '用电量',
      text8: '历史数据',
      text9: '环境状况',
      text10: '总测量时间',
      text11: '灯损坏',
      text12: '修理',
      text13: '空气净化器损坏',
      text13_1: '传感器损坏',
      text14: '名称',
      text15: '设备ID',
      text16: 'HCL路灯计划',
      text17: '编辑',
      text18: '历史数据',
      text19: '照明控制',
      text20: 'HCL路灯自动',
      text21: '始终关闭',
      text22: '始终关闭手动',
      text23: '自动化',
      text24: '亮度',
      text25: '色温',
      text26: '今天日出',
      text27: '设置日出',
      text28: '当前',
      text29: '色温',
      text30: '今天日落',
      text31: '设置日落',
      text32: '手动控制HCL路灯',
      text33: '亮度',
      text34: '色温',
      text35: '模拟试验',
      text36: '当前时间',
      text37: '日出',
      text38: '日落',
      text39: '启动',
      text40: '设备状态',
      text41: '电池电量',
      text42: '电池状态',
      text43: '连接状态',
      text44: '无线强度',
      text45: '设备控制',
      text46: '开 / 关',
      text47: '连接状态',
      text48: '使用时间',
      text49: '过滤器剩余有效时间',
      text50: '主照明',
      text51: '自动HCL路灯',
      text52: '晚上放松模式',
      text53: '夜间照明模式',
      text54: '起床时间和睡觉时间设置',
      text55: '起床时间',
      text56: '睡觉时间',
      text57: '型号',
      text58: '网关ID',
      text59: '正常',
      text60: '故障',
      text61: '线形图',
      text62: '柱状图',
      text63: '当天',
      text64: '周',
      text65: '月',
      text66: '年',
      text67: '设备详情',
      text68: '设备管理',
      text69: '设备详情',
      text70: '灯的名称：',
      text71: '不支持',
      text72: '演示模式',
      text73: '传感器',
    },
    uvLight: {
      text1: '添加UV灯',
      text2: '编辑UV灯',

      text3: '设备名称',
      text4: '网关SN',
      text5: '网关串口',
      text6: '设备地址',
      text7: '一键打开',
      text8: '一键关闭',

      tableLabel1: '设备名称',
      tableLabel2: '设备地址',
      tableLabel3: '楼层',
      tableLabel4: '房间',
      tableLabel5: '连接状态',
      tableLabel6: '1路',
      tableLabel7: '2路',
      tableLabel8: '3路',
      tableLabel9: '4路',
      tableLabel10: '更新时间',
      tableLabel11: '操作',

      tableText1: '在线状态',
      tableText2_1: '已开启',
      tableText2_0: '已关闭',
      tableText3: '异常状态',
      tableText4: '已运行',

      onlineStatusTetx1: '离线',
      onlineStatusTetx2: '在线',

      faultStatusText1: '正常',
      faultStatusText2: '异常',

    },
    lights: {
      text1: '删除',
      text2: '亮度',
      text3: '色温',
      text4: '刷新',
      text5: '添加设备',
      text6: '操作',
      text7: '编辑',
      text8: '历史',
      text9: '更新',
      text10: '选择所有',
      text11: '硬件版本',
      text12: '软件版本',
      text13: '编辑灯',
      text14: '添加灯',
      text15: '图表',
      text16: '表格',
      text17: '下载',
      text18: '能源消耗',
      text19: '照明使用时间表',
      text20: '更新',
      text21: '目前的版本很低。请现在升级。',
      text22: '失败，请再次点击下载',
      text23: '当前最新版本',
      text24: '搜索设备名称或者设备ID',
      text25: '电压',
      text26: '电流',
      text27: '亮度',
      text28: '色温',
      text29: '电力消耗',
      text30: '网络状态',
      text31: '故障状态',
      text32: '更新时间',
      text33: '序号',
      text34: '工作时间',
      text35: '查看',
      text36: '网络',
      text37: '编辑设备',
      text38: '集中设置',
      text39: '全开模式',
      text40: '全关模式',
      text41: '上课模式',
      text42: '下课模式',
      text43: '午休模式',
      text44: '自习模式',
      text45: '板书模式',
      text46: '投影模式',
      text47: '自动',
      text48: '关',
      text49: '开',
      text50: '按钮',
      text51: '照度值',
      text52: '读取',
      text53: '设置',
      text54: '当前照度值',
      text55: '恒定照度值',
      text56: '设备模式信息',
      text57: '用电量',
    },
    circadianLights: {
      text1: '编辑 HCL路灯',
      text2: '添加 HCL路灯',
      text3: '000000000',
      text4: '000000000',
      text5: '000000000',
      text6: '000000000',
      text7: '000000000',
      text8: '000000000',
      text9: '000000000',
      text10: '000000000',
    },
    sensor: {
      text1: '编辑传感器',
      text2: '添加传感器',
      text3: '温度统计',
      text4: '湿度统计',
      text5: 'CO₂ 统计',
      text6: 'PM2.5 统计',
      text7: 'TVOC 统计',
      text8: '甲醛 统计',
      text9: '连接状态',
      text10: 'PM10 统计',
    },
    airPurifiers: {
      text1: '设置',
      text2: '设备工作时间',
      text3: '滤网工作时间',
      text4: '滤网工作模式',
      text5: '小时',
      text6: '风扇转速',
      text7: '关掉',
      text8: 'AQI',
      text9: '低',
      text10: '中',
      text11: '高',
      text12: '手动模式',
      text13: '自动模式(AQ)',
      text14: '编辑空气净化器',
      text15: '添加空气净化器',
      text16: '最新更新时间',
      text17: '夜晚开始时间',
      text18: '夜晚结束时间',
      text19: '工作模式',
      text20: '输入传感器阈值以设置空气净化器风扇转速',
      text21: '归零',
      text22: '延时时间',
      text23: '秒',
      text24: '自动模式（独立）',
      text25: '设置分组',
      text26: '闪一闪',
      text27: '情景模式',
    },
    gateway: {
      text1: '搜索网关名称或网关ID',
      text2: '添加网关',
      text3: 'WIFI',
      text4: '连接的设备',
      text5: '添加网关',
      text6: '网关ID',
      text7: '检查周期',
      text8: '配置网络',
      text9: '已关联',
      text10: '未关联',
      text11: '未命名',
      text12: '附近没有发现任何设备。',
      text13: 'SSID',
      text14: '密码',
      text15: 'wifi配置大约需要2分钟，请耐心等待…',
      text16: '重试',
      text17: '已成功连接wifi',
      text18: '切换WiFi',
      text19: '请连接WiFi',
      text20: '没有数据',
      text21: 'Wifi名称不能为空',
      text22: 'Wifi密码不能为空',
      text23: '指令下发成功。',
      text24: '无法连接WiFi',
      text25: '网关不在线',
      text26: '搜索',
      text27: 'RS-485 未关联',
    },
    service: {
      text1: '所有设备',
      text2: '推送设定',
      text3: '维修人员',
      text4: '报警配置文件',
      text5: '维修',
      text6: '标记处理',
      text7: '维修信息',
      text8: '失败原因',
      text9: '维修人',
      text10: '维修申请时间',
      text11: '维修完成时间',
      text12: '维修',
      text13: '维修人员',
      text14: '所有设备',
      text15: '未维修',
      text16: '维修中',
      text17: '已修复',
      text18: '设备类型',
      text19: '错误代码',
      text20: '异常状态',
      text21: '添加报警配置文件',
      text22: '权限',
      text23: '编辑警报配置文件',
      text24: '查看警报配置文件',
      text25: '选择数据类型',
      text26: '设定条件',
      text27: '设定参数',
      text28: '时间',
      text29: '添加',
      text30: '设定温度',
      text31: '设定 CO₂',
      text32: '设定 AQI',
      text33: '设定是否连接',
      text34: '每天',
      text35: '添加维修人员',
      text36: '编辑维修人员',
      text37: '酒店权限',
      text38: '所有权限',
      text39: '联系电话',
      text40: '酒店数量',
      text41: '人数',
      text42: '添加推送人员',
      text43: '编辑推送人员',
      text44: '接受者',
      text45: '推送类型',
      text46: '设备',
      text47: '所有酒店',
      text48: '已配置',
      text49: '未配置',
      text50: '酒店',
      text51: '联系电话',
      text52: '启用',
      text53: '断开连接',

      text54: '过滤器超过有效时间',
      text55: '温度异常',
      text56: '二氧化碳异常',
      text57: 'AQI异常',
      text58: '离线异常',

      text59: '是否取消',
      text60: '未取消',
      text61: '已取消',
      text62: '设定 pm2.5',
      text63: '设定 pm10',
      text64: '设定 TVOC',
      text65: '设定 甲醛',
      text66: '更多操作',
      text67: '通知通道',
      text68: '取消告警',
    },
    activityHistory: {
      text1: '用户操作',
      text2: '用户',
      text3: '操作',
      text4: '日志时间',
      text5: '描述',
      text6: '000000000',
      text7: '000000000',
      text8: '000000000',
      text9: '000000000',
      text10: '000000000',
      text11: '000000000',
    },
    userManagement: {
      text1: '添加用户',
      text2: '系统管理员',
      text3: '酒店管理员',
      text4: '酒店用户',
      text5: '人员资料',
      text6: '用户权限',
      text7: '选择权限',
      text8: '酒店管理',
      text9: '酒店用户',
      text10: '用户账号',
      text11: '帐户名称长度为4到20个字符',
      text12: '帐户ID长度为4到20个字符',
      text13: '账号名称',
      text14: '联系电话',
      text15: '帐户类型',
      text16: '启用',
    },
    siteManagement: {
      text1: '添加酒店',
      text2: '添加单位',
      text3: 'HCL灯计划',
      text4: '添加建筑',
      text5: '添加楼层',
      text6: '添加房间',
      text7: '编辑楼层',
      text8: '删除楼层',
      text9: '编辑酒店',
      text10: '编辑单位',
      text11: '地址',
      text12: '经度',
      text13: '纬度',
      text14: '编辑建筑',
      text15: '建筑名称',
      text16: '单层',
      text17: '多层',
      text18: '起始楼层',
      text19: '结束楼层',
      text20: '编辑房间',
      text21: '房间名称',
      text22: '房间ID',
      text23: 'SN',
      text24: '编辑 logo',
      text25: '请上传不超过2m的PNG，JPG格式的图片',
      text26: '点击上传酒店logo',
      text27: '上传进度',
      text28: '上传成功',
      text29: '上传失败',
      text30: '设置警报配置文件',
      text31: '警报配置',
      text32: '请输入正确的纬度和经度',
      text33: '无法识别，请更改搜索内容',
      text34: '未选择建筑或楼层',
      text35: '未选择建筑',
      text36: '地址不能为空',
      text37: '经度不能为空',
      text38: '纬度不能为空',
      text39: 'HCL灯计划',
      text40: '上传HCL灯计划',
      text41: '设备映射',
      text42: '请以以下格式上传或下载 ',
      text43: ' 模板',
      text44: ' 用于编辑',
      text45: '上传人',
      text46: '上传时间',
      text47: '上传',
    },
    message: {
      text1: '系统提示',
      text2: '确认',
      text3: '是否确认删除?',
      text4: '提示',
      text5: '确定',
      text6: '取消',
      text7: '已取消删除',
      text8: '不能升级',
      text9: '设备不在线',
      text10: '是最新版本',
      text11: '请选择设备',
      text12: '灯:',
      text13: '不在线',
      text14: '没有网关绑定',
      text15: '设备未绑定到网关',
      text16: '您确定要删除设备吗?',
      text17: '警告',
      text18: '已取消删除',
      text19: 'HCL灯名称：',
      text20: '传感器名称:',
      text21: '空气净化器名称:',
      text22: '设备名称:',
      text23: '未选中',
      text24: '是否确认删除网关?',
      text25: '您确定要删除该服务吗？',
      text26: '您确定要标记并处理当前故障吗？',
      text27: '您确定要删除警报配置文件吗？',
      text28: '您确定要删除维修人员吗？',
      text29: '仅以JPG，PNG格式上传图片！',
      text30: '上传图片的大小不能超过2MB！',
      text31: '您确定要删除该用户吗？',
      text32: '您确定要删除房间吗？',
      text33: '您确定要删除该建筑吗？',
      text34: '您确定要删除该楼层吗？',
      text35: '您确定要删除该酒店吗？',
      text36: '您确定要删除该计划吗？',
      text37: '睡眠时间应该比起床时间晚4个小时',
      text38: '请等待上一个操作返回',
      text39: '是否确认取消故障？',
      text40: '确定要清空工作时间吗?',

      delDevText: '是否确认从数据库删除设备?',
    }
  }
}